var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.26 17.5236L21.385 23.6486C21.9422 24.2058 21.9422 25.1092 21.385 25.6664C20.8278 26.2236 19.9244 26.2236 19.3672 25.6664L12.2333 18.5325C11.6761 17.9753 11.6761 17.0719 12.2333 16.5147L19.3672 9.38082C19.9244 8.82362 20.8278 8.82362 21.385 9.38082C21.9422 9.93801 21.9422 10.8414 21.385 11.3986L15.26 17.5236Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevLeft);
export default __webpack_public_path__ + "static/media/ChevLeft.e6dfbed6062eae75ab845229f01b1ed5.svg";
export { ForwardRef as ReactComponent };